import { map, pick } from 'lodash'

const transformToSaveDishTypesArgs = data =>
  map(data, (node, index) => ({
    ...pick(node, ['id', 'name', 'parentId', 'isCurationEnabled', 'isIgnored']),
    children: transformToSaveDishTypesArgs(node.children),
    position: index,
  }))

export default transformToSaveDishTypesArgs
